import React from "react";
import classNames from "classnames";
import CiroContainer from "./CiroContainer";
import CiroLink from "./CiroLink";

const CapacityLimitMessage = () => {
  return (
    <CiroContainer className={classNames("bg-zinc-100")}>
      <div
        className={classNames("w-full", "max-w-2xl", "mx-auto", "text-left")}
      >
        <div
          className={classNames(
            "bg-white",
            "rounded-lg",
            "shadow-md",
            "p-8",
            "border",
            "border-gray-200",
          )}
        >
          <div className={classNames("mb-6")}>
            <h1
              className={classNames(
                "text-2xl",
                "font-semibold",
                "text-gray-900",
                "mb-4",
              )}
            >
              We're at capacity.
            </h1>
            <div className={classNames("text-gray-700", "space-y-4")}>
              <p>
                Ciro's AI agents are being pushed to their limits by current
                demand.
              </p>
              <p>
                To protect quality, we're temporarily prioritizing searches for
                existing customers and early waitlist signups.
              </p>
              <p>
                If you're new and want to move up the queue, we'd love to hear
                more about your use case{" "}
                <CiroLink href="https://tally.so/r/3EVgKB">
                  in this form
                </CiroLink>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </CiroContainer>
  );
};

export default CapacityLimitMessage;
